import GoBack from "./GoBack";
import ReactStars from "react-rating-stars-component";
import { MdGrade, MdOutlineGrade } from "react-icons/md";
// import { ImSpinner8 } from "react-icons/im";
import classNames from "classnames";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { FormikHelpers, useFormik } from "formik";
import validationSchema, {
  rateInteractionInitialValues,
} from "../schemas/rateInteraction.schema";
import { useRateInteractionMutation } from "../generated/graphql";
import StatusModal from "./StatusModal";
import { useDisclosure } from "@chakra-ui/react";

interface rateInput {
  clinic_experience: number;
  practitioner: number;
  chw: number;
  environment: number;
  collecting_prescription: number;
  waiting_time: number;
}

export default function Rating() {
  const [show, setshow] = useState(true);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const location = useLocation();
  const state = location.state as any as { id?: number };
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [rateInteraction, { loading, data, error }] =
    useRateInteractionMutation();

  async function handleSubmit(
    values: rateInput,
    _formikHelpers: FormikHelpers<rateInput>
  ) {
    setShowErrorModal(false);
    try {
      await rateInteraction({
        variables: {
          input: {
            interactionId: state?.id,
            clinicRating: values.clinic_experience,
            chwRating: values.chw,
            practitionerRating: values.practitioner,
            cleanlinessRating: values.environment,
            prescriptionCollectionRating: values.collecting_prescription,
            waitingTimeRating: values.waiting_time,
          },
        },
      });
    } catch (error) {
      setShowErrorModal(true);
    } finally {
      onOpen();
    }
  }

  const formik = useFormik({
    initialValues: rateInteractionInitialValues,
    onSubmit: handleSubmit,
    validationSchema,
  });

  const Error = ({ name }) => (
    <>
      {formik.errors[name] && formik.touched[name] && (
        <small className="text-red-500">{formik.errors[name]}</small>
      )}
    </>
  );

  const RateMsg = ({ name }) => (
    <>
      {formik.values[name] === 1 ? (
        <p className="text-[.75rem] mb-6">Terrible</p>
      ) : formik.values[name] === 2 ? (
        <p className="text-[.75rem] mb-6">Very Bad</p>
      ) : formik.values[name] === 3 ? (
        <p className="text-[.75rem] mb-6">Just Average</p>
      ) : formik.values[name] === 4 ? (
        <p className="text-[.75rem] mb-6">Pretty Good</p>
      ) : formik.values[name] === 5 ? (
        <p className="text-[.75rem] mb-6">Excellent</p>
      ) : (
        <p className="text-[.75rem] mb-6">Choose</p>
      )}
    </>
  );

  // useEffect(() => {
  //   if (!state?.id) {
  //     return navigate(-1 as any, { replace: true });
  //   }

  //   return setshow(true);
  // }, []);

  return (
    <>
      {show && (
        <div className="pt-10 px-4">
          <GoBack />

          <form onSubmit={formik.handleSubmit} className="text-center mt-6">
            <div className="mb-10">
              <p className="mb-4">How was your experience at the clinic?</p>
              <RateMsg name={"clinic_experience"} />

              <div className="flex justify-center">
                <ReactStars
                  count={5}
                  // @ts-ignore
                  onChange={(newRating) => {
                    formik.setFieldValue("clinic_experience", newRating);
                  }}
                  activeColor="#FBBC05"
                  value={formik.values.clinic_experience}
                  emptyIcon={<MdOutlineGrade size={30} color="#FBBC05" />}
                  filledIcon={<MdGrade size={30} color="#FBBC05" />}
                />
              </div>
              <Error name={"clinic_experience"} />
            </div>

            <div className="mb-10">
              <p className="mb-4">
                How was your experience with the practitioner?
              </p>
              <RateMsg name={"practitioner"} />
              <div className="flex justify-center">
                <ReactStars
                  count={5}
                  // @ts-ignore
                  onChange={(newRating) => {
                    formik.setFieldValue("practitioner", newRating);
                  }}
                  classNames="react-stars"
                  activeColor="#FBBC05"
                  value={formik.values.practitioner}
                  emptyIcon={<MdOutlineGrade size={30} color="#FBBC05" />}
                  filledIcon={<MdGrade size={30} color="#FBBC05" />}
                />
              </div>
              <Error name={"practitioner"} />
            </div>

            <div className="mb-10">
              <p className="mb-4">
                How was your experience with the community health worker?
              </p>
              <RateMsg name={"chw"} />

              <div className="flex justify-center">
                <ReactStars
                  count={5}
                  // @ts-ignore
                  onChange={(newRating) => {
                    formik.setFieldValue("chw", newRating);
                  }}
                  classNames="react-stars"
                  activeColor="#FBBC05"
                  value={formik.values.chw}
                  emptyIcon={<MdOutlineGrade size={30} color="#FBBC05" />}
                  filledIcon={<MdGrade size={30} color="#FBBC05" />}
                />
              </div>
              <Error name={"chw"} />
            </div>

            <div className="mb-10">
              <p className="mb-4">
                How was the cleanliness of the environment of the hospital or
                health care center?
              </p>
              <RateMsg name={"environment"} />

              <div className="flex justify-center">
                <ReactStars
                  count={5}
                  classNames="react-stars"
                  // @ts-ignore
                  onChange={(newRating) => {
                    formik.setFieldValue("environment", newRating);
                  }}
                  activeColor="#FBBC05"
                  value={formik.values.environment}
                  emptyIcon={<MdOutlineGrade size={30} color="#FBBC05" />}
                  filledIcon={<MdGrade size={30} color="#FBBC05" />}
                />
              </div>
              <Error name={"environment"} />
            </div>

            <div className="mb-10">
              <p className="mb-4">
                How was your experience with collecting your prescription?
              </p>
              <RateMsg name={"collecting_prescription"} />
              <div className="flex justify-center">
                <ReactStars
                  count={5}
                  // @ts-ignore
                  onChange={(newRating) => {
                    formik.setFieldValue("collecting_prescription", newRating);
                  }}
                  activeColor="#FBBC05"
                  value={formik.values.collecting_prescription}
                  emptyIcon={<MdOutlineGrade size={30} color="#FBBC05" />}
                  filledIcon={<MdGrade size={30} color="#FBBC05" />}
                />
              </div>
              <Error name={"collecting_prescription"} />
            </div>

            <div>
              <p className="mb-4">
                How was your experience with in terms of waiting time to access
                care?
              </p>
              <RateMsg name={"waiting_time"} />
              <div className="flex justify-center">
                <ReactStars
                  count={5}
                  classNames="react-stars"
                  // @ts-ignore
                  onChange={(newRating) => {
                    formik.setFieldValue("waiting_time", newRating);
                  }}
                  activeColor="#FBBC05"
                  value={formik.values.waiting_time}
                  emptyIcon={<MdOutlineGrade size={30} color="#FBBC05" />}
                  color="#FBBC05"
                  filledIcon={<MdGrade size={30} />}
                />
              </div>
              <Error name={"waiting_time"} />
            </div>

            <div className="flex justify-end">
              <button
                disabled={loading}
                type={"submit"}
                className={classNames(
                  "bg-blue-500 font-bold relative outline-none ring-1 ring-blue-500 focus-visible:bg-white focus-visible:text-blue-500 py-2 px-6 mt-14 text-lg rounded-full text-white flex justify-end"
                  // { "opacity-20": "loading" }
                )}
              >
                Submit
                {/* {"loading" && (
            <div className="absolute top-0 left-0 w-full flex justify-center bg-opacity-20 items-center h-full">
              <ImSpinner8 className="animate-spin" />
            </div>
          )} */}
              </button>
            </div>
          </form>
        </div>
      )}

      {showErrorModal ? (
        <StatusModal
          isOpen={isOpen}
          onClose={onClose}
          text={error.message}
          status={"Error"}
          samePageNav={true}
        />
      ) : (
        <StatusModal
          isOpen={isOpen}
          onClose={onClose}
          text={"You completed a rating!"}
        />
      )}
    </>
  );
}
